/**
 * The "Edit your accounts" link under Your Plan's figures. Opens the self-funding accounts step
 * directly; see `useEditAccountsLink` for when it shows.
 */
import { Pencil } from 'lucide-react';
import { Button } from '@design-system';
import { useEditAccountsLink } from '../hooks/use-edit-accounts-link';

export function EditAccountsLink({ clientId }: { clientId: string }) {
  const { isVisible, open } = useEditAccountsLink(clientId);
  if (!isVisible) return null;

  return (
    <Button
      variant="link"
      className="self-start px-0 has-[>svg]:px-0"
      onClick={open}
      data-testid="edit-accounts-link"
    >
      <Pencil />
      Edit your accounts
    </Button>
  );
}
